export const engagementApiSegmentCohortsTextToSql = "/engagement/api/segment_cohorts/text_to_sql";
